import { Base_Url } from "../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../ApiMethods/ApiMethod";

const LeavesUrl = `${Base_Url}/Leave`;

export const GetLeaveList = async (params) => {
    const res = await postApiWithAuthorization(`${LeavesUrl}/GetLeaveList`, params);
    return res;
};

export const AddUpdateLeave = async (params) => {
    const res = await postApiWithAuthorization(`${LeavesUrl}/AddUpdateLeave?ModuleName=${params.ModuleName}`, params);
    return res;
};
export const GetLeaveModel = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeavesUrl}/GetLeaveModel?ModuleName=${ModuleName}&LeaveKeyID=${KeyID}&UserKeyID=${UserKeyID}`);
    return res;
};

export const ChangeLeaveStatus = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeavesUrl}/ChangeLeaveStatus?ModuleName=${ModuleName}&LeaveKeyID=${KeyID}&UserKeyID=${UserKeyID}`);
    return res;
};

export const DeleteLeave = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeavesUrl}/DeleteLeave?ModuleName=${ModuleName}&LeaveKeyID=${KeyID}&UserKeyID=${UserKeyID}`);
    return res;
};